import { render } from "./MobileMessagePopup.vue?vue&type=template&id=ac43ef32&scoped=true&ts=true"
import script from "./MobileMessagePopup.vue?vue&type=script&lang=ts"
export * from "./MobileMessagePopup.vue?vue&type=script&lang=ts"

import "./MobileMessagePopup.vue?vue&type=style&index=0&id=ac43ef32&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac43ef32"]])

export default __exports__